<template>
    <div class="add-product-holder">
        <b-card no-body>
            <b-tabs  v-model="tabIndex" pills card>
                <b-tab  v-bind:disabled="basicDisabled" title="Basic">
                    <b-card-text>
                        <basic @form-basic="formBasic"
                               @change-product-type="setProductType"
                               @set-product-id="setProductId"
                               @set-factory-id="setFactoryId"
                               @set-step-completed="setStepCompleted"
                               @set-tab-index="setTabIndex"
                               @clear-style-designs="clearStyleDesigns"
                               :step_completed="step_completed"
                               :addons="addons"
                        />
                    </b-card-text>
                </b-tab>
                <b-tab title="Product Designs" class="styles-fields" v-bind:disabled="fieldsDisabled">
                    <b-card-text>
                        <fields :svgGroups="svgGroups" v-if="product_type.code" ref="fieldComponent" @active_basic_tab="ActiveBasicTab"
                                @product_styles="getProductStyles"
                                :product_type="product_type"
                                :product_id="product_id"
                                :factory_id="factory_id"
                                @set-step-completed="setStepCompleted"
                                @set-tab-index="setTabIndex"
                                @set-reversible="setReversible"
                                @updateSvgGroups="updateSvgGroups"
                                @clearSvgGroups="clearSvgGroups"

                        />
                    </b-card-text>
                </b-tab>
                <b-tab title="Customization Journey" v-bind:disabled="designsDisabled">
                    <b-card-text>
                        <designs :svgGroups="svgGroups" v-if="product_type.code"  @finalStep="saveProductStep3" @fields-tab="ActiveFieldsTab"
                                 :product_type="product_type"
                                 :product_id="product_id"
                                 :factory_id="factory_id"
                                 :reversible="is_reversible"
                                 @set-step-completed="setStepCompleted"
                        />
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import Basic from './Basic.vue';
import Fields from './Fields.vue';
import Designs from './Designs.vue';
import { http } from "@/config/httpCommon"
export default{
  components:{
      Basic,
      Fields,
      Designs,
  },
  created() {
    if(this.$route.params.id) {
      this.$store.dispatch('getJourney', this.$route.params.id);
    }
      this.getAddOns();
  },
  data() {
    return{
      form: {
        id: 0,
        category_ids: [],
        url_slug: '',
        product_name: '',
        product_type:'',
        step_completed: 0,
        product_models: [],
        is_description_enabled: 0,
        description: '',
        is_logo_allowed: 0,
        allowed_logos_count: null,
        limit_max_logo_upload: false,
        name_font_ids: [],
        name_color_ids: [],
        front_layer_id: 0,
        product_styles: [],
        logos_setting: [],
        product_color_ids: [],
        product_names: [], //name/number placement of journey tab loop
        size_container_ids: [],
        accessories_container_ids: [],
        roster_caps_letter: false,
        addons: [],
        sizes: [],
      },
      product_styles: '',
      basic: '',
      journey: '',
      basicDisabled: false,
      fieldsDisabled: true,
      designsDisabled: true,
      tabIndex: 0,
      data: [],
      product_type:{},
      product_id:0,
      factory_id:0,
      is_reversible: false,
      step_completed:0,
      addons: [],
      svgGroups: []
    }
  },
  methods: {
    updateSvgGroups(payload) {
      this.svgGroups.push(payload);
    },
    clearSvgGroups() {
      this.svgGroups = [];
    },
    formBasic(series){
      this.basic = series;
    },
    getProductStyles(styles){
      this.product_styles = styles;
      if(this.step_completed > 1){
        this.designsDisabled = false;
      }
    },
    async saveProductStep3(journey, proceed){
      let JourneyFormData = {};

      this.journey = journey;

      JourneyFormData.product_id = this.product_id
      JourneyFormData.product_color_ids = [];
      for(let index =0; index<this.journey.selected_colors.length; index++){
        JourneyFormData.product_color_ids.push(this.journey.selected_colors[index].id);
      }
      JourneyFormData.is_logo_allowed = this.journey.allow_logo_upload;
      JourneyFormData.allowed_logos_count = (this.journey.limit_max_logo_upload) ? this.journey.max_logo_allowed: 0;
      JourneyFormData.limit_max_logo_upload = this.journey.limit_max_logo_upload;
      JourneyFormData.allow_extra_text = this.journey.allow_extra_text
      JourneyFormData.allow_name_number = (this.journey.allow_name_number == true) ? 1 : 0;
      JourneyFormData.preview_custom_texts = (this.journey.preview_custom_texts == true) ? 1 : 0;
      JourneyFormData.allow_fixed_logo = (this.journey.allow_fixed_logo == true) ? 1 : 0;
      JourneyFormData.logos_setting = [];
      for(let i=0; i<this.journey.logos_setting.length; i++){
        let logo = this.journey.logos_setting[i];
        JourneyFormData.logos_setting.push({
          x_axis: logo.x_axis,
          y_axis: logo.y_axis,
          rotation: logo.rotation,
          width: logo.width,
          height: logo.height,
          name_of_placement: logo.name_of_placement,
          // Reversible products (AB#19064): the side option encodes side+face
          // as 'front'|'back'|'front-inside'|'back-inside' — split into the
          // composite fields the backend stores (side + face, AB#19554).
          logo_side: logo.side.id.replace('-inside', ''),
          face: logo.side.id.endsWith('-inside') ? 'inside' : 'outside',
          is_locked: logo.is_locked,
          logos_follows_product: logo.logos_follows_product ? 1 : 0,
          following_product_ids: this.getProductIds(logo.following_product_ids),
          logoTechnologies: logo.logoTechnologies,
        })
      }

      JourneyFormData.product_styles = [];
      for (let count=0; count<this.product_styles.length; count++){
        let style = this.product_styles[count];
        let data = {
          id:style.id,
         }


        JourneyFormData.product_styles.push(data);
      }

      JourneyFormData.name_font_ids = [];
      if (this.journey.name_number_fonts && this.journey.name_number_fonts.length){
        for(let index =0; index<this.journey.name_number_fonts.length; index++){
          let font = this.journey.name_number_fonts[index];
          JourneyFormData.name_font_ids.push(font.id)
        }
      }
      JourneyFormData.product_pattern_ids = {};
      if (this.journey.selected_pattern){
        JourneyFormData.product_pattern_ids = this.journey.selected_pattern.id
      }
      JourneyFormData.name_color_ids = [];
      for(let c=0; c<this.journey.name_number_colors.length; c++){
        let color = this.journey.name_number_colors[c];
        JourneyFormData.name_color_ids.push(color.id);
      }
      JourneyFormData.product_texts = []
      if(JourneyFormData.allow_name_number) {
        JourneyFormData.product_texts = this.journey.product_texts
      }
      JourneyFormData.product_names = [];
      for(let i=0; i<this.journey.name_numbers_placement.length; i++){
        let placement = this.journey.name_numbers_placement[i];
        JourneyFormData.product_names.push({
          x_axis: placement.x_axis,
          y_axis: placement.y_axis,
          width: placement.width,
          height: placement.height,
          rotation: placement.rotation,
          name_of_placement: placement.name_of_placement,
          side: placement.side.id.replace('-inside', ''),
          face: placement.side.id.endsWith('-inside') ? 'inside' : 'outside',
          arc_text_allowed: placement.arc_text_allowed,
          outline_enabled: placement.outline_enabled,
          type: placement.type.id,
          is_locked: placement.is_locked,
          text_follows_product: placement.text_follows_product ? 1 : 0,
          following_product_ids:this.getProductIds(placement.following_product_ids),
          name_of_placement_follow: placement.name_of_placement_follow
        })
      }
      JourneyFormData.size_container_ids = [];
      if(this.journey.size_container){
        JourneyFormData.size_container_ids.push(this.journey.size_container.id);
      }
      JourneyFormData.accessories_container_ids = [];
      if(this.journey.size_container){
        JourneyFormData.accessories_container_ids.push(this.journey.size_container.id);
      }
      JourneyFormData.roster_caps_letter = this.journey.roster_caps_letter;
      JourneyFormData.addons = [];
      for (let accIndex =0; accIndex < this.journey.accessories_container.length; accIndex++){
        JourneyFormData.addons.push(this.journey.accessories_container[accIndex].id);
      }
      JourneyFormData.svg_group_color_container = this.journey.svg_group_color_container

      try {
        this.$store.commit('set', ['showLoader', true]);
        await this.$store.dispatch('saveProductStep3', JourneyFormData);
        this.$store.commit('set', ['showLoader', false]);

        if (proceed == 0) {
          this.showToast('Product has been saved successfully','SUCCESS')
          this.$router.push('/products');
        }else{
          this.showToast('Product has been saved successfully','SUCCESS')
        }

      } catch (err) {
        this.showError(err);
      }
    },
    async journeyData(journey){
      this.journey = journey;
      //============== basic tab ===============
      this.form.url_slug = this.basic.slug;
      this.form.product_name = this.basic.prod_name;
      this.form.product_type = this.basic.product_type;
      this.form.is_published = this.basic.published;
      this.form.is_custom_color_allowed = this.basic.custom_color;
      this.form.sku = this.basic.sku;
      this.form.custom_color = this.basic.custom_color;
      //======================= designs tab =================
      this.form.product_styles = [];
      for (let count=0; count<this.product_styles.length; count++){
        let style = this.product_styles[count];
        let data = {
          id:style.id,
          style_front_layer_id: style.style_front_layer_id,
          style_back_layer_id: (style.style_back_layer_id != '') ? style.style_back_layer_id: 0,
          style_name: style.tab_title,
        }
        let designs = [];
        for (let inc=0; inc<style.designs.length; inc++){
          designs.push({
            front_design: style.designs[inc].front_design,
            back_design: style.designs[inc].back_design,
            design_name: style.designs[inc].design_name,
            is_active: style.designs[inc].is_published,
            is_default: style.designs[inc].is_default,
          })
        }
        data.design = designs;

        this.form.product_styles.push(data);
      }
      //================ journey tab ===============
      this.form.product_color_ids = [];
      for(let index =0; index<this.journey.selected_colors.length; index++){
        this.form.product_color_ids.push(this.journey.selected_colors[index].id);
      }
      this.form.is_logo_allowed = this.journey.allow_logo_upload;
      this.form.allowed_logos_count = (this.journey.limit_max_logo_upload) ? this.journey.max_logo_allowed: 0;
      this.form.limit_max_logo_upload = this.journey.limit_max_logo_upload;
      this.form.logos_setting = [];
      for(let i=0; i<this.journey.logos_setting.length; i++){
        let logo = this.journey.logos_setting[i];
        this.form.logos_setting.push({
          x_axis: logo.x_axis,
          y_axis: logo.y_axis,
          rotation: logo.rotation,
          width: logo.width,
          height: logo.height,
          name_of_placement: logo.name_of_placement,
          logo_side: logo.side.id.replace('-inside', ''),
          face: logo.side.id.endsWith('-inside') ? 'inside' : 'outside',
          is_locked: logo.is_locked,
        })
      }
      this.form.name_font_ids = [];
      for(let index=0; index<this.journey.name_number_fonts.length; index++){
        let font = this.journey.name_number_fonts[index];
        this.form.name_font_ids.push(font.id);
      }
      this.form.name_color_ids = [];
      for(let c=0; c<this.journey.name_number_colors.length; c++){
        let color = this.journey.name_number_colors[c];
        this.form.name_color_ids.push(color.id);
      }
      this.form.product_names = [];
      for(let i=0; i<this.journey.name_numbers_placement.length; i++){
        let placement = this.journey.name_numbers_placement[i];
        this.form.product_names.push({
          x_axis: placement.x_axis,
          y_axis: placement.y_axis,
          width: placement.width,
          height: placement.height,
          rotation: placement.rotation,
          name_of_placement: placement.name_of_placement,
          side: placement.side.id.replace('-inside', ''),
          face: placement.side.id.endsWith('-inside') ? 'inside' : 'outside',
          arc_text_allowed: placement.arc_text_allowed,
          outline_enabled: placement.outline_enabled,
          type: placement.type.id,
          is_locked: placement.is_locked,
        })
      }
      this.form.size_container_ids = [];
      for(let count = 0; count<this.journey.size_container.length; count++){
        this.form.size_container_ids.push(this.journey.size_container[count].id);
      }
      this.form.accessories_container_ids = [];
      for(let count = 0; count<this.journey.size_container.length; count++){
        this.form.accessories_container_ids.push(this.journey.size_container[count].id);
      }
      this.form.roster_caps_letter = this.journey.roster_caps_letter;
      this.form.addons = [];
      for (let accIndex =0; accIndex < this.journey.accessories_container.length; accIndex++){
        this.form.addons.push(this.journey.accessories_container[accIndex].id);
      }

      try{
        if(this.$route.params.id) {
          this.form.id = this.$route.params.id;
          await this.$store.dispatch('updateProduct', this.form);
        }else{
          await this.$store.dispatch('addProduct', this.form);
        }
        this.$router.push('/products');
      }catch (err){
        this.showError(err);
      }
    },
    getProductIds(product_ids){
      let ids = []
      if (product_ids)
        for (let i= 0; i<product_ids.length; i++){
          ids.push(product_ids[i].id)
        }
      return ids
    },
    ActiveBasicTab(){
     // this.basicDisabled = false;
     // this.fieldsDisabled = true;
     // this.designsDisabled = true;
      this.tabIndex = 0;

    },
    ActiveFieldsTab(){
    //  this.fieldsDisabled = false;
     // this.designsDisabled = true;
      this.tabIndex = 1;
    },
    setProductType(product_type){
      this.product_type = product_type;
    },
    setProductId(product_id){
      this.product_id = product_id;
    },setFactoryId(factory_id){
      this.factory_id = factory_id;
    },
    setReversible(is_reversible){
      this.is_reversible = !!is_reversible;
    },
    setTabIndex(tabindex, isnext) {

      if (isnext != '') {
       this.$nextTick(() => {
          this.tabIndex = tabindex;
        })
      } else {
       this.tabIndex = tabindex;
      }
    },
    setStepCompleted(step){
      if(step > this.step_completed){
        this.step_completed = step;
      }

      if(step == 1 && this.step_completed < 2){
        this.basicDisabled = false
        this.fieldsDisabled = false
        this.designsDisabled = true
      }
      if(step == 2 || step== 3){
        this.basicDisabled = false
        this.fieldsDisabled = false
        this.designsDisabled = false
      }
    },
    clearStyleDesigns(){
      this.designsDisabled = true;
      this.$refs.fieldComponent.clearContainerDesigns()
    },
    getAddOns() {
      http.get("addons").then(response => {
        const response_data = response.data
        if(response_data.success) {
          this.addons = response_data.result.addons
        } else {
          this.showError(response_data.message)
        }
      }, error => {
        this.showError("Error while getting addons", error)
      })
    }
  }
}
</script>
<style type="text/css" scope>
    .model_postion{
        width: 45px;
    }
    .add-product-holder .card{border: none;}
    .add-product-holder .nav-pills .nav-link{
        background: #E8E8E8;
        color: #A1A1A1;
        border-radius: 15px 15px 0 0;
        padding: 0.5rem 1.5rem;
        font-size: 18px;
        font-weight: 300;
    }
    .add-product-holder .nav-pills .nav-link.active{
        background: #009FE3;
        color: #fff;
    }
    .add-product-holder .card-header{
        padding: 0 3rem;
        margin: 0 -2rem;
    }
    .add-product-holder .nav-item{margin: 0 25px 10px 0;}
    .add-product-holder .card-header-pills{
        margin: 0;
    }
    .btn-add-fields{
        position: relative;
        color: #fff;
        padding: 0;
        margin: 0;
        background: #009FE3;
        font-size: 34px;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        text-align: center;
        z-index: 2;
        border-color: #009FE3;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
    .btn-add-fields:before{
        position: absolute;
        content: '';
        left: 3px;
        right: 3px;
        top: 3px;
        bottom: 3px;
        border: 2px solid #fff;
        border-radius: 50%;
    }
    .btn-add-fields span{margin: -5px 0 0;}
    .styles-fields{
        padding: 1.25rem 0;
    }

    @media only screen and (max-width: 1430px){
      .custom-switch.b-custom-control-lg .custom-control-label{font-size: 1rem;}
    }

    .remove-icon{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2em;
      height: 30px;
      width: 30px;
      background: #C80000;
      color: #fff;
      border-radius: 99px;
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      transition: 0.2s all ease;
      z-index: 30;
    }

    .remove-icon:hover{
      background: #ff0000;
    }

    .btn-primary.light{
      background: #c8e4f3 !important;
      border-color: #c8e4f3 !important;
      color: #009FE3 !important;
    }
</style>
